import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import AppErrorBoundary from './components/AppErrorBoundary';
import { isChunkLoadError, reloadOnceForChunkError } from './utils/chunkReload';
import './index.css';
import './mobile-responsive.css';

// Vite fires `vite:preloadError` when a dynamically imported asset fails to load
// — the classic symptom of a tab still running an older build after a deploy.
// Recover by reloading once (throttled inside the helper) so the browser pulls
// the new, content-hashed chunks instead of showing a broken screen.
window.addEventListener('vite:preloadError', (event) => {
  event.preventDefault();
  reloadOnceForChunkError();
});

// Belt-and-braces: a module-load failure can also surface as an unhandled error.
window.addEventListener('error', (event) => {
  if (isChunkLoadError(event?.error ?? event?.message)) {
    reloadOnceForChunkError();
  }
});

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <React.StrictMode>
    <AppErrorBoundary>
      <App />
    </AppErrorBoundary>
  </React.StrictMode>,
);
